import React from "react";
import { Table, TableHead, TableBody, TableCell, TableRow } from "@mui/material";
import moment from "moment";

const PackingMaterialDownload = ({ formContent }) => {
  return (
    <div className="premium-print-container">
      <div className="section-divider">
        <h1 className="section-title">PACKING MATERIAL ISSUED SHEET</h1>
      </div>

      <div className="data-grid">
        <div className="data-item">
          <span className="data-label">Customer Name</span>
          <span className="data-value">{formContent?.customerName || "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Packing/Shifting Date</span>
          <span className="data-value">{formContent?.packingShifting || "-"}</span>
        </div>
      </div>

      <div className="data-grid">
        <div className="data-item">
          <span className="data-label">Vehicles Used</span>
          <span className="data-value">{formContent?.vehicles || "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Packers Used</span>
          <span className="data-value">{formContent?.packers || "-"}</span>
        </div>
      </div>

      <div className="section-divider" style={{ marginTop: '30px' }}>
        <h2 className="section-title" style={{ fontSize: '12pt' }}>MATERIAL INVENTORY</h2>
      </div>

      <table className="w-100" style={{ marginTop: '10px' }}>
        <thead>
          <tr>
            <th style={{ width: '50px' }}>No.</th>
            <th>Item Name</th>
            <th style={{ width: '150px' }}>Date Issued</th>
            <th style={{ width: '100px' }}>Qty Issued</th>
            <th style={{ width: '100px' }}>Qty Used</th>
            <th style={{ width: '120px' }}>Qty Returned</th>
          </tr>
        </thead>
        <tbody>
          {formContent?.dataRows?.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell>{idx + 1}</TableCell>
              <TableCell style={{ fontWeight: 600 }}>{row.description || "-"}</TableCell>
              <TableCell>{row.date1 ? moment(row.date1).format("Do MMM, YYYY") : "-"}</TableCell>
              <TableCell align="center">{row.qtyIssued || "-"}</TableCell>
              <TableCell align="center" style={{ fontWeight: 700 }}>
                {Number(row.qtyIssued || 0) - Number(row.qtyReturned || 0)}
              </TableCell>
              <TableCell align="center">{row.qtyReturned || "-"}</TableCell>
            </TableRow>
          ))}
          {(!formContent?.dataRows || formContent.dataRows.length === 0) && (
            <TableRow>
              <TableCell colSpan={6} align="center" style={{ padding: '20px' }}>
                No records found
              </TableCell>
            </TableRow>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PackingMaterialDownload;
